import React from "react";
import classes from "./Outline.module.css";

const Outline = ({ sessionData }) => {
  // 1. Safe guard: If there's no data yet, render nothing
  if (!sessionData || !sessionData.slide_blueprint) return null;

  // 2. Extract slides safely
  let slides = [];
  if (sessionData.slide_blueprint.slides) {
    slides = sessionData.slide_blueprint.slides;
  } else if (Array.isArray(sessionData.slide_blueprint)) {
    slides = sessionData.slide_blueprint;
  }

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <div className={classes.header}>
          <div>
            <h1 className={classes.title}>Slide Outline (CP-3)</h1>
            <p className={classes.subtitle}>
              Review the deck structure. Tell the AI in the chat if you want to add, remove, reorder, or edit titles before writing begins!
            </p>
          </div>
        </div>

        <div className={classes.slideList}>
          {slides.map((slide, index) => (
            <div key={slide.slide_id || index} className={classes.slideItem}>
              <div className={classes.slideHeader}>
                <span className={classes.badge}>Slide {slide.sequence || index + 1}</span>
              </div>

              <div className={classes.inputGroup}>
                <label className={classes.label}>Slide Title</label>
                <div 
                  className={classes.input} 
                  style={{ background: "#f8fafc", padding: "10px", borderRadius: "6px", border: "1px solid #e2e8f0" }}
                >
                  {slide.title}
                </div>
              </div>

              <div className={classes.inputGroup}>
                <label className={classes.label}>Objective / Instructions</label>
                <div 
                  className={classes.input} 
                  style={{ background: "#f8fafc", padding: "10px", borderRadius: "6px", border: "1px solid #e2e8f0", minHeight: "60px" }}
                >
                  {slide.objective}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Outline;